// extracted by mini-css-extract-plugin
export default {"wrapperDonateHeader":"DonateHeader_wrapperDonateHeader__Fzyrm","donateHeader":"DonateHeader_donateHeader__kMuyq","donateSubheader":"DonateHeader_donateSubheader__Uq8gs"};